import { render, staticRenderFns } from "./SemenDestructionDisposal.vue?vue&type=template&id=5d1fbb0a&scoped=true&"
import script from "./SemenDestructionDisposal.vue?vue&type=script&lang=js&"
export * from "./SemenDestructionDisposal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1fbb0a",
  null
  
)

export default component.exports